import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Spinner } from 'common/spinner';
import { AppContext } from 'context/app-context';
import { getQueryParamsObject } from 'helpers/utils';
import { withAuth } from 'hocs/auth/with-auth';
import { RouteName } from 'routes';
import { getRouteFor } from 'routes/route-helpers';
import { history } from 'routes/routes';

// The old vault view mode (/vaults/:id/view-mode) now forwards to the new
// screens: a signed-in member to their Memories view, anyone else to the
// public vault view. Old contributor links (?token=) keep their sign-up box
// on the public page.
const LegacyVaultViewModeRedirect = () => {
  const { id } = useParams<{ id: string }>();
  const { state } = useContext(AppContext);

  useEffect(() => {
    const queryParams = getQueryParamsObject();
    const target =
      state.logged && !queryParams.token
        ? getRouteFor(RouteName.MemoriesViewScreen, { id })
        : getRouteFor(RouteName.VaultViewMode, { vaultId: id }, queryParams);
    history.replace(target);
  }, []);

  return <Spinner />;
};

const LegacyVaultViewMode = withAuth(LegacyVaultViewModeRedirect, true);

export { LegacyVaultViewMode };
